import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class HiloProductsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllHiloProducts(router){
    const url = `/api/hiloProducts`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getAllHiloProductsForFlightSchool(schoolId, router){
    const url = `/api/hiloProducts/school/${schoolId}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getHiloProductById(id, router) {
    const url = `/api/hiloProducts/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  addProductToFlightSchool(payload, router){
    const url = `/api/hiloProducts/add`
    return this.CommonAPIService.postCall(url, payload, router)
  }

  /*createHiloProduct(params, router) {
    const url = `/api/hiloProducts`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateHiloProduct(id, params, router) {
    const url = `/api/hiloProducts/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteHiloProduct(id, router) {
    const url = `/api/hiloProducts/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }*/

}
export default HiloProductsAPIService;
